import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const transcend = defineConnector({
  identifier: "transcend",
  name: "Transcend",
  tagLine: "Privacy and data governance automation",
  logo,
  protocol: "http",
  tags: ["data"],
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create a Transcend API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Transcend, create an API key and use it as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.transcend.io/v1/data-silo",
  },
  defaultUrlPattern: () => "https://api\\.transcend\\.io/.*",
});
